<template>
    <div class="modal fade fixed-end" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="drawer-title">
                        Project Stage
                    </h2>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">

                    <div class="row" v-if="!editStage.id">
                        <div class="col-md-12">
                            <div class="mb-3">
                                <label class="control-label">Type:</label>
                                <multiselect v-model="editStage.stage" :options="stages" label="name" track-by="id" @select="typeSelected"></multiselect>
                            </div><!-- /.form-group -->
                        </div>
                    </div>

                    <template v-if="editStage.stage_id">

                        <div class="row">
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label class="control-label">Start Date</label>
                                    <datepicker v-bind:value="editStage.commenced" @input="selectedStartDate" input-class="form-control" :clear-button=true></datepicker>
                                </div><!-- /.form-group -->
                            </div>
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label class="control-label">End Date</label>
                                    <datepicker v-bind:value="editStage.completed" @input="selectedFinishDate" input-class="form-control" :clear-button=true></datepicker>
                                </div><!-- /.form-group -->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label class="control-label">Budget</label>
                                    <div class="input-group">
                                        <input class="form-control" v-model="editStage.budget_hours" type="number">
                                        <span class="input-group-text">hrs</span>
                                    </div>
                                </div><!-- /.form-group -->
                            </div>

                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label class="control-label">Status:</label>
                                    <multiselect v-model="editStage.status" :options="statusList" label="name" track-by="id" @select="statusSelected"></multiselect>
                                </div><!-- /.form-group -->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label class="control-label">Stage Lead</label>
                                    <multiselect v-model="editStage.lead" :options="users" label="name" track-by="id" @select="leadSelected"></multiselect>
                                </div><!-- /.form-group -->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label class="control-label">Members:</label>
                                    <multiselect v-model="editStage.members" :options="users" label="name" track-by="id" :multiple="true" :close-on-select="false"></multiselect>
                                </div><!-- /.form-group -->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label class="control-label">Warranty Start Date</label>
                                    <datepicker v-bind:value="editStage.warranty_start" @input="selectedWarrantyStartDate" input-class="form-control" :clear-button=true></datepicker>
                                </div><!-- /.form-group -->
                            </div>
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label class="control-label">Warranty End Date</label>
                                    <datepicker v-bind:value="editStage.warranty_end" @input="selectedWarrantyEndDate" input-class="form-control" :clear-button=true></datepicker>
                                </div><!-- /.form-group -->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label class="control-label">Evaluation Start Date</label>
                                    <datepicker v-bind:value="editStage.evaluation_start" @input="selectedEvaluationStartDate" input-class="form-control" :clear-button=true></datepicker>
                                </div><!-- /.form-group -->
                            </div>
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label class="control-label">Evaluation End Date</label>
                                    <datepicker v-bind:value="editStage.evaluation_end" @input="selectedEvaluationEndDate" input-class="form-control" :clear-button=true></datepicker>
                                </div><!-- /.form-group -->
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="control-label">Linked Opportunity</label>
                            <div class="input-group">
                                <div class="flex-grow-1">
                                    <multiselect v-model="editStage.opportunity" :options="opportunities" label="formatted_name" track-by="id" @select="opportunitySelected"></multiselect>
                                </div> 
                                <div class="d-flex">
                                    <router-link v-if="editStage.opportunity_id" class="btn btn-link text-info" target="_blank" tag="a" :to="{ name: 'opportunities.overview', params: { 'opportunity_id': editStage.opportunity_id }}"><i class="far fa-external-link"></i></router-link>
                                </div>
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="control-label">Linked Budget</label>
                            <div class="input-group">
                                <div class="flex-grow-1">
                                    <multiselect v-model="editStage.budget" :options="budgets" label="name" track-by="id" @select="budgetSelected"></multiselect>
                                </div> 
                                <div class="d-flex" v-if="editStage.budget_id">
                                    <router-link class="btn btn-link text-info" target="_blank" tag="a" :to="{ name: 'budgets.overview', params: { 'budget_id': editStage.budget_id }}"><i class="far fa-external-link"></i></router-link>
                                </div>
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="control-label">Linked SLA</label>
                            <div class="input-group">
                                <div class="flex-grow-1">
                                    <multiselect v-model="editStage.sla" :options="slas" label="name" track-by="id" @select="slaSelected"></multiselect>
                                </div> 
                                <div class="d-flex" v-if="editStage.sla_id">
                                    <router-link class="btn btn-link text-info" target="_blank" tag="a" :to="{ name: 'slas.show', params: { 'sla_id': editStage.sla_id }}"><i class="far fa-external-link"></i></router-link>
                                </div>
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="control-label">Linked Runn Project</label>
                            <div class="input-group">
                                <div class="flex-grow-1">
                                    <multiselect :value="runnValue" :options="runnProjects" label="name" track-by="id" @input="(value) => this.editStage.runn_id = value ? value.id : null " v-if="runnProjects"></multiselect>
                                </div> 
                                <div class="d-flex" v-if="editStage.runn_id">
                                     <a v-bind:href="`https://app.runn.io/projects/${editStage.runn_id}`" target="_blank" class="btn btn-link text-info"><i class="far fa-external-link"></i></a>
                                </div>
                            </div>
                        </div>

                    </template>

                
                    <div class="modal-footer justify-content-between">
                        <a href="#" class="text-danger" @click.prevent="confirmDelete">Delete Project Stage</a>
                        <div>
                            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                            <c-button @click="save" class="btn btn-rounded btn-primary">Save</c-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { http, notify } from 'utils'
    import Multiselect from 'vue-multiselect'
    import Datepicker from 'vuejs-datepicker'
    import { unset, cloneDeep } from 'lodash'
    import { LaddaButton } from 'components/form/input'
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
    import { CModal } from '@chameleon/chameleon-vue'

    export default {
        extends: CModal,

        components: {
            LaddaButton,
            Multiselect,
            Datepicker
        },

        props: [
            'mode'
        ],

        data() {
            return {
                editStage: {},
                stages: [
                    {id: 1, name: "Discovery"},
                    {id: 2, name: "Prototype"},
                    {id: 3, name: "Development"}

                ]
            }
        },

        computed: {
            ...mapState('yodizproject/stages', {
                stage: 'single'
            }),
            ...mapState('users', ['users']),
            ...mapState('opportunityList', ['opportunities']),
            ...mapState('budgetList', ['budgets']),
            ...mapState('slaList', ['slas']),
            ...mapState('runnProjectsList', {
                runnProjects: 'projects'
            }),
            ...mapGetters('status', ['stage1List', 'stage2List', 'stage3List']),
            ...mapGetters('status', {getStatus: 'getById'}),

            statusList () {
                switch(this.editStage.stage_id) {
                    case 1:
                        return this.stage1List;
                    break;
                    case 2:
                        return this.stage2List;
                    break;
                    case 3:
                        return this.stage3List;
                    break;
                }

                return [];
            },
            runnValue: {
                get () { 
                    return this.runnProjects.find(option => option.id === this.editStage.runn_id)
                }
            }
        },

        mounted() {
            this.getStatuses()

            this.getUsers()
            this.getOpportunities()
            this.getBudgets()
            this.getSlas()
            this.getRunnProjects()

            this.addEventListener('open', () => {
                this.editStage = cloneDeep(this.stage)
            });
        },

        methods: {
            ...mapActions('users', ['getUsers']),
            ...mapActions('opportunityList', ['getOpportunities']),
            ...mapActions('budgetList', ['getBudgets']),
            ...mapActions('slaList', ['getSlas']),
            ...mapActions('runnProjectsList', ['getRunnProjects']),
            ...mapActions('status', ['getStatuses']),
            ...mapActions('yodizproject/stages', {
                update: 'updateSingle',
                create: 'addSingle',
                delete: 'deleteSingle'
            }),

            statusSelected(selected) {
                this.editStage.status_id = selected.id
            },

            leadSelected(selected) {
                this.editStage.lead_id = selected.id
            },

            typeSelected(selected) {
                this.editStage.stage_id = selected.id
            },

            opportunitySelected(selected) {
                this.editStage.opportunity_id = selected.id
            },

            budgetSelected(selected) {
                this.editStage.budget_id = selected.id
            },

            slaSelected(selected) {
                this.editStage.sla_id = selected.id
            },

            selectedStartDate(e) {
                if (e) {
                    let d = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds()));
                    this.editStage.commenced = moment(d).format("YYYY-MM-DD")
                } else {
                    this.editStage.commenced = null
                }
            },

            selectedFinishDate(e) {
                if (e) {
                    let d = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds()));
                    this.editStage.completed = moment(d).format("YYYY-MM-DD")
                } else {
                    this.editStage.completed = null
                }
            },

            selectedWarrantyStartDate(e) {
                if (e) {
                    let d = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds()));
                    this.editStage.warranty_start = moment(d).format("YYYY-MM-DD")
                } else {
                    this.editStage.warranty_start = null
                }
            },

            selectedWarrantyEndDate(e) {
                if (e) {
                    let d = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds()));
                    this.editStage.warranty_end = moment(d).format("YYYY-MM-DD")
                } else {
                    this.editStage.warranty_end = null
                }
            },

            selectedEvaluationStartDate(e) {
                if (e) {
                    let d = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds()));
                    this.editStage.evaluation_start = moment(d).format("YYYY-MM-DD")
                } else {
                    this.editStage.evaluation_start = null
                }
            },

            selectedEvaluationEndDate(e) {
                if (e) {
                    let d = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds()));
                    this.editStage.evaluation_end = moment(d).format("YYYY-MM-DD")
                } else {
                    this.editStage.evaluation_end = null
                }
            },

            async save() {
                if (!this.editStage.id) {
                    await this.create(this.editStage);
                } else {
                    await this.update({id: this.stage.id, payload: this.editStage});
                }

                this.close()
            },

            confirmDelete() {

                this.$swal(
                    {
                        title: 'Confirm Delete', 
                        html: 'Are you sure you want to delete this stage?',
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Delete',
                    }).then( () => {
                        
                        this.delete(this.stage.id).then(() => {
                            // Wait for the drawer to finish hiding so the backdrop is removed before navigating away
                            this.$el.addEventListener('hidden.bs.modal', () => {
                                this.$router.push({ name: 'projects.index' })
                            }, { once: true })
                            this.close()
                        })
                    }, function() {
                });
            },
        }
    }
</script>